import { Routes, Route, Navigate } from "react-router-dom";
import PublicLayout from "@/components/marketing/PublicLayout";
import Landing from "@/pages/Landing";
import Services from "@/pages/Services";
import Process from "@/pages/Process";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

import PortalLayout from "@/components/portal/PortalLayout";
import PortalLogin from "@/pages/portal/PortalLogin";
import PortalDashboard from "@/pages/portal/PortalDashboard";
import PortalSpark from "@/pages/portal/PortalSpark";
import PortalDeliverables from "@/pages/portal/PortalDeliverables";
import PortalROI from "@/pages/portal/PortalROI";

import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminClients from "@/pages/admin/AdminClients";
import AdminSpark from "@/pages/admin/AdminSpark";
import AdminBSS from "@/pages/admin/AdminBSS";
import AdminServiceCatalog from "@/pages/admin/AdminServiceCatalog";
import AdminROI from "@/pages/admin/AdminROI";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<Landing />} />
        <Route path="/services" element={<Services />} />
        <Route path="/process" element={<Process />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Route>

      <Route path="/portal/login" element={<PortalLogin />} />
      <Route path="/portal" element={<PortalLayout />}>
        <Route index element={<PortalDashboard />} />
        <Route path="spark" element={<PortalSpark />} />
        <Route path="deliverables" element={<PortalDeliverables />} />
        <Route path="roi" element={<PortalROI />} />
      </Route>

      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="clients" element={<AdminClients />} />
        <Route path="spark" element={<AdminSpark />} />
        <Route path="bss" element={<AdminBSS />} />
        <Route path="catalog" element={<AdminServiceCatalog />} />
        <Route path="roi" element={<AdminROI />} />
      </Route>

      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
